import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import App from "./App";
import "./assets/styles/global.css";
import applyBrand from "./theme/applyBrandCssVariables";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";

// Apply the active brand (REACT_APP_BRAND) before first paint: set CSS
// variables on :root and load the brand's webfonts.
applyBrand();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Suspense fallback="">
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </Suspense>,
);

serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
